// extracted by mini-css-extract-plugin
module.exports = {"container":"PayInvoiceOutsideNoodleModal_container__jvLq8"};